import { render, staticRenderFns } from "./NexmoLookupPage.vue?vue&type=template&id=418032d6&scoped=true"
import script from "./NexmoLookupPage.vue?vue&type=script&lang=js"
export * from "./NexmoLookupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418032d6",
  null
  
)

export default component.exports